import { consultScope, isBlockedSession } from '@/utils/promoterAccess';
import { sessionMenu } from '@/utils/sessionMenu';

export default {
  isInternalUser(state) {
    return Boolean(state.userInfo.internal_employee);
  },
  /**
   * A session on a promoter the user no longer works at only consults. The field
   * is absent before /users/me answers and on an API that predates it, and both
   * mean the ordinary session — anything else would blank the menu on every reload.
   */
  isPromoterActive(state) {
    return state.userInfo.promoter_active !== false;
  },
  consultScope(state) {
    return consultScope(state.userInfo.consult);
  },
  sessionMenu(state) {
    return sessionMenu(state.userInfo);
  },
  isPromoterBlocked(state) {
    return isBlockedSession(state.userInfo);
  },
  promoterName(state) {
    return state.userInfo.promoter_name || '';
  },
};
